import type * as React from 'react';
import { get } from '@Domain/Api';
import subjectTypeIconsFetched, {
	type SubjectTypeIconsFetchedAction,
	type SubjectTypeIconsFetchedPayload,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeIconsFetched';
import subjectTypeIconsFetchFailed, {
	type SubjectTypeIconsFetchFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeIconsFetchFailed';
import type FetchSubjectTypeIcons from '@Application/SubjectTypeDefinitions/Queries/FetchSubjectTypeIcons';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectTypeIconsFetchedAction | SubjectTypeIconsFetchFailedAction;

export default (_query: FetchSubjectTypeIcons) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<SubjectTypeIconsFetchedPayload>(
				`${parameters.api.host}/api/enums/subject-type-icons`,
			);

			const action = subjectTypeIconsFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectTypeIconsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
